import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
let CacheManagementService = class CacheManagementService {
    constructor(cacheManagementApi) {
        this.cacheManagementApi = cacheManagementApi;
    }
    getRedisNamespaces() {
        return this.cacheManagementApi.getRedisNamespaces();
    }
    getRedisValue(params) {
        return this.cacheManagementApi.getRedisValue(params);
    }
    synchronizationRedis() {
        return this.cacheManagementApi.synchronizationRedis();
    }
    synchronizationRedisByType(params) {
        return this.cacheManagementApi.synchronizationRedisByType(params);
    }
    updateTopic() {
        return this.cacheManagementApi.updateTopic();
    }
};
CacheManagementService = __decorate([
    injectable(),
    __param(0, inject(Symbols.CacheManagementApi)),
    __metadata("design:paramtypes", [Object])
], CacheManagementService);
export { CacheManagementService };
